<template>
  <div class="sustainability-environment">
    <div class="decoration-element">
      <div class="decoration-element-2"></div>
    </div>
    <div class="row row-1">
      <div class="img-and-text img-and-text-sm">
        <img
          class="row-1-top-img desktop"
          src="../../assets/img/sustainability/environment/img_left.jpg"
        >
        <div class="text-group">
          <h3 class="text-accent">{{ $t('sustainability-environment-1') }}</h3>
          <h1>{{ $t('sustainability-environment-2') }}</h1>
          <!-- <h2>{{ $t('sustainability-environment-3') }}</h2> -->
          <img
            class="row-1-top-img mobile"
            src="../../assets/img/sustainability/environment/img_left.jpg"
          >
          <p v-html="$t('sustainability-environment-4')"></p>
          <p v-html="$t('sustainability-environment-5')"></p>
          <p class="strong">{{ $t('sustainability-environment-6') }}</p>
          <img style="width: 100%" src="../../assets/img/sustainability/environment/chb.png" alt="">
          
        </div>
      </div>
      <div class="img-and-btn">
        <Carousel :imgs="imgs"/>
        <!-- <div class="btn-arrow" @click="toggleScroll()">
          <span class="kcm toggle-down">C</span>
        </div>-->
      </div>
    </div>
        <div class="content-row" v-if="$i18n.locale === 'bg'">
      <Files :color="'#5ead43'" :files="files" />
    </div>
  </div>
</template>

<script>
import Carousel from './Carousel';
import Files from '../products/individuals/shared/Files';

export default {
  data() {
    return {
      imgs: [
        require('../../assets/img/sustainability/environment/img_right.jpg'),
        require('../../assets/img/sustainability/environment/2.jpg'),
        require('../../assets/img/sustainability/environment/3.jpg')
      ],
      files: {
        bg: [
          'Мерки за безопасност и начини на действие в случай на авария.pdf'
        ],
        en: [
        ]
      }
    };
  },
  components: {
    Carousel,
    Files
  },
  methods: {
    toggleScroll() {
      const btn = document.getElementsByClassName('btn-arrow')[0];
      const scrollTop =
        window.pageYOffset || document.documentElement.scrollTop;
      window.scrollTo({
        top: btn.getBoundingClientRect().bottom + scrollTop,
        behavior: 'smooth'
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.sustainability-environment {
  position: relative;
}

.mobile {
  display: none;
}

.content-row {
  padding: 0 $sidesPadding 25px;
}
@media screen and (max-width: 1600px) {
  .content-row {
  padding: 0 $sidesPadding1600 25px;
}
}
@media screen and (max-width: 1280px) {
  .content-row {
  padding: 0 $sidesPadding1280 25px;
}
}
@media screen and (max-width: 1000px) {
  .row-1 {
    padding: $sidesPadding1280 0 0;
    flex-direction: column;
    .desktop {
      display: none;
    }
    .mobile {
      display: block;
    }
    .img-and-text {
      width: 100%;
      .row-1-top-img {
        width: 100%;
      }
      .text-group {
        margin: 0;
        padding: 0 $sidesPadding1280;
      }
    }
    .img-and-btn {
      width: 100%;
      padding: 0;
      .carousel {
        height: 50vw;
      }
      .carousel,
      img {
        width: 100%;
        margin: 0;
      }
      .btn-arrow {
        display: none;
      }
    }
  }
}
@media screen and (max-width: 600px) {
  .row-1 {
    padding: $sidesPadding600 0 0;
    .img-and-text {
      .text-group {
        padding: 0 $sidesPadding600;
      }
    }
  }
   .content-row {
  padding: 0 $sidesPadding600 25px;
   }
}
</style>
